<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiSendCheck } from "@mdi/js";
export default {
  name: "MdiSendCheck",
  data() {
    return {
      svgPath: mdiSendCheck,
    };
  },
};
</script>
